import { useEffect, useRef } from 'react';
import { DISPATCH_EVENTS } from '../../../../utils/constants/commonConstants';

/** Refetches once when the user returns to this tab after a hover-card CTA opened AICA in another tab. */
export function useRefetchOnReturnAfterCta(enabled: boolean, refetch: () => void) {
    const refetchRef = useRef(refetch);
    refetchRef.current = refetch;

    useEffect(() => {
        if (!enabled) return;
        let ctaClicked = false;
        const markCtaClicked = () => {
            ctaClicked = true;
        };
        const refetchOnReturn = () => {
            if (!ctaClicked || document.visibilityState !== 'visible') return;
            ctaClicked = false;
            refetchRef.current();
        };
        document.addEventListener(DISPATCH_EVENTS.ENTITY_HOVER_CTA_CLICK, markCtaClicked);
        document.addEventListener('visibilitychange', refetchOnReturn);
        window.addEventListener('focus', refetchOnReturn);
        return () => {
            document.removeEventListener(DISPATCH_EVENTS.ENTITY_HOVER_CTA_CLICK, markCtaClicked);
            document.removeEventListener('visibilitychange', refetchOnReturn);
            window.removeEventListener('focus', refetchOnReturn);
        };
    }, [enabled]);
}
